import {
  DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
  DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
} from 'common/components';
import { METAL_ROOF_LANDING_NAME } from '../../metal-roof-constants';
import {
  METAL_ROOF_IMAGE_LIST_MAP,
  METAL_ROOF_MAIN_PAGE_IMAGE_NAME_LIST,
  METAL_ROOF_MAIN_PAGE_SEAM_ROOFING_IMAGE_NAME_LIST,
  MetalRoofGalleryStructure,
} from './metal-roof-gallery-section-constants';

export const getGalleryList = (roofType: string, withSeamRoofing: boolean): MetalRoofGalleryStructure[] => {
  let imageList = METAL_ROOF_IMAGE_LIST_MAP[roofType];
  let folderName = roofType;

  if (!imageList) {
    imageList = withSeamRoofing
      ? METAL_ROOF_MAIN_PAGE_SEAM_ROOFING_IMAGE_NAME_LIST
      : METAL_ROOF_MAIN_PAGE_IMAGE_NAME_LIST;
    folderName = 'main-page';
  }

  return imageList.map(({ name, addText, subFolder }, index: number) => {
    const imageName = index + 1;
    const folder = subFolder ? `${folderName}/${subFolder}` : folderName;

    const baseInfo = {
      alt: name,
      addText,
      name: `${imageName}.jpg`,
      src: `${METAL_ROOF_LANDING_NAME}/gallery-popup/${folder}/${imageName}.jpg/${imageName}.jpg`,
      srcSmall: `${METAL_ROOF_LANDING_NAME}/gallery/${folder}/${imageName}.jpg/${imageName}.jpg`,
      transformations: DEFAULT_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
    };

    if (index % 10 === 4 || index % 10 === 7) {
      return {
        ...baseInfo,
        transformations: DEFAULT_BIG_IMAGE_TWO_COLUMNS_TRANSFORMATIONS,
      };
    }

    return baseInfo;
  });
};
